export const PIL = {
    symbol: 'PIL',
    decimals: 18,
};
export const WETH = {
    symbol: 'WETH',
    decimals: 18,
};
export const USDC = {
    symbol: 'USDC',
    decimals: 6,
};
export const XPIL = {
    symbol: 'xPIL',
    decimals: 18,
};
export const DENOMINATORS = [PIL, WETH, USDC];
export const CATEGORIES = [
    "Uniswap",
    "Art",
    "DeFi",
    "DAOs",
    "Games",
    "Utilities",
    "Worlds",
    "Others",
];
// export const CATEGORIES = [
//   'Tag0',
//   'Tag1',
//   'Tag2',
//   'Tag3',
//   'Tag4',
// ];
export const ORDER_BY = {
    0: {
        description: 'Date Listed: Newest',
        orderBy: 'timestamp',
        orderDirection: 'desc'
    },
    1: {
        description: 'Date Listed: Oldest',
        orderBy: 'timestamp',
        orderDirection: 'asc'
    },
    2: {
        description: 'TVL: Highest',
        orderBy: 'tvlETH',
        orderDirection: 'desc'
    },
    3: {
        description: 'TVL: Lowest',
        orderBy: 'tvlETH',
        orderDirection: 'asc'
    },
};
export const INITIAL_ROUNDS = 10000;
export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
export const CHAINS = {
    mainnet: 1,
    ropsten: 3,
    rinkeby: 4,
    polygon: 137,
    optimism: 10,
    arbitrum: 42161,
    local: 31337,
};
export const CHAIN_NAMES = {
    1: 'mainnet',
    '0x1': 'mainnet',
    3: 'ropsten',
    '0x3': 'ropsten',
    4: 'rinkeby',
    '0x4': 'rinkeby',
    137: 'polygon',
    '0x89': 'polygon',
    10: 'optimism',
    '0xa': 'optimism',
    42161: 'arbitrum',
    '0xa4b1': 'arbitrum',
    31337: 'local',
    '0x7a69': 'local',
};
